import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["name", "slug"]

  slugify(string) {
    return string.toLowerCase()
      .replace(/[^\w\s-]/g, '')
      .replace(/[\s_-]+/g, '-')
      .replace(/^-+|-+$/g, '')
      .substring(0, 100);
  }

  updateSlug() {
    const title = this.nameTarget.value;
    const slug = this.slugTarget.value;
    if (!slug.trim().length) {
      this.slugTarget.value = this.slugify(title);
    }
  }
}